"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeSessionStorageItem = exports.setSessionStorageItem = exports.getSessionStorageItem = void 0;
// Fallback inmemory option. This will used if browser doesnt support sessionStorage or access is prevented to use it.
const tempStorage = new Map();
const getSessionStorageItem = (key) => {
    var _a;
    try {
        return window.sessionStorage.getItem(key);
    }
    catch (_b) {
        return (_a = tempStorage.get(key)) !== null && _a !== void 0 ? _a : null;
    }
};
exports.getSessionStorageItem = getSessionStorageItem;
const setSessionStorageItem = (key, value) => {
    try {
        window.sessionStorage.setItem(key, value);
    }
    catch (_a) {
        tempStorage.set(key, value);
    }
};
exports.setSessionStorageItem = setSessionStorageItem;
const removeSessionStorageItem = (key) => {
    try {
        window.sessionStorage.removeItem(key);
    }
    catch (_a) {
        tempStorage.delete(key);
    }
};
exports.removeSessionStorageItem = removeSessionStorageItem;
//# sourceMappingURL=sessionStorageHelper.js.map